import { render, staticRenderFns } from "./app-authorizations-select.vue?vue&type=template&id=55faaa62&scoped=true&"
import script from "./app-authorizations-select.vue?vue&type=script&lang=js&"
export * from "./app-authorizations-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55faaa62",
  null
  
)

export default component.exports